import { useFormContext } from 'react-hook-form';

export const useSpreedlyGlobalErrors = () => {
  const {
    formState: { errors },
  } = useFormContext();

  return Object.values(errors.global?.errors ?? {});
};
